<template>
  <div
    class="button-sm button-sm-elect"
    :disabled="disabled"
    @click="addToElect"
  >
    <button class="button-sm__btn button-sm-elect__btn" :disabled="disabled">
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 0L9.11986 4.33747L14 4.96556L10.43 8.27435L11.3262 13L7 10.7075L2.67376 13L3.57 8.27435L0 4.96556L4.88014 4.33747L7 0Z"
          fill="white"
        />
      </svg>
    </button>
    <p class="button-sm__text button-sm-edit__text" v-if="title">{{ title }}</p>
  </div>
</template>

<script>
import IndexedDB from '@/controllers/IndexedDb.js'

export default {
  name: 'app-button-sm-edit',
  props: {
    disabled: Boolean,
    title: String,
    electedName: String,
    elected: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data () {
    return {}
  },
  methods: {
    async addToElect () {
      const elected = this.elected
      const electedName = this.electedName

      if (elected && electedName) {
        if (!window.indexedDB) {
          console.log(
            "Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available."
          )
        } else {
          IndexedDB.open('Elect', 1, db => {
            if (!db.objectStoreNames.contains(electedName)) {
              db.createObjectStore(electedName, { keyPath: 'id' })
            }
          }).then(() => {
            if (elected instanceof Array) {
              Promise.allSettled(elected.map(item => IndexedDB.add(item, electedName)))
                .then(() => {
                  this.$emit('then')
                })
            } else {
              IndexedDB.add(elected, electedName).then(() => this.$emit('then'))
            }
          })
        }
      } else {
        this.$emit('addToElect')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/system/_vars";
@import "../../../assets/css/system/_mixins";

.button-sm {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &__btn {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $font_color_alt;
    height: 30px;
    width: 30px;
    border-radius: 3px;
    transition: 0.3s;
    cursor: pointer;
    user-select: none;
    font-family: $font_main;
  }

  &__text {
    transition: 0.3s;
    margin-left: 10px;
  }

  &[disabled] {
    color: $color_deactive;
    pointer-events: none;

    .button-sm__btn {
      background: $color_deactive;
      box-shadow: none;
    }
  }
}

.button-sm-elect {
  &__btn {
    background: $button_color_third;
    box-shadow: 0px 2px 2px #1170b8;
  }

  &:hover {
    .button-sm-elect__btn {
      box-shadow: none;
    }

    .button-sm-edit__text {
      color: #207eb5;
    }
  }

  &:active {
    .button-sm-elect__btn {
      box-shadow: inset 0px 4px 4px #1170b8;
    }
  }
}
</style>
